import React, { useState } from 'react'
import { FormControl, TextField } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import { Link, withRouter } from 'react-router-dom'
import firebase from '../firebase'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';


function Register(props) {
	const { classes } = props
	const [name, setName] = useState('')
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')

	const theme = createMuiTheme({
		palette: {
		  primary: {
			main: '#919191'
		  }
		},
	  });

	  const baseURL = process.env.PUBLIC_URL;

	return (
		<ThemeProvider theme={theme}>
		<main className="login">
			<header className="loginHeader">
				<img className="logoLogin2" src={require('../../images/logo.svg')} />
				<h3 className="loginHTitleHeader">REGISTRO</h3>
			</header>

			<form id="form" onSubmit={e => e.preventDefault() && false }>
				<p className="msj_regis">Si no hiciste el registro de "primera clase" vuelve a la web y rellena el formulario</p>
				<FormControl margin="normal" required fullWidth>
					<TextField variant="outlined" color="primary" id="name" name="name" label="Nombre y apellido" autoComplete="off" autoFocus value={name} onChange={e => setName(e.target.value)} />
				</FormControl>
				<FormControl margin="normal" required fullWidth>
					<TextField variant="outlined" color="primary" id="email" name="email" autoComplete="off" label="Email" value={email} onChange={e => setEmail(e.target.value)}  />
				</FormControl>
				<FormControl margin="normal" required fullWidth>
					<TextField variant="outlined" color="primary" name="password" type="password" id="password" label="Contraseña" autoComplete="off" value={password} onChange={e => setPassword(e.target.value)}  />
				</FormControl>
			</form>
			<div className="btnContainerLogin">
				<div type="submit" className="loginBtnPrincipal" onClick={onRegister}>Registrarme</div>
				<Link to={baseURL+"/login"}><div className="loginBtnSecundary red">Ya tengo una cuenta</div></Link>
			</div>
		</main>
		</ThemeProvider>
	)

	async function onRegister() {
		if (name !== ''){
			try {
				await firebase.register(name, email, password)
				props.history.replace(baseURL+'/dashboard')
			} catch(error) {
				alert(error.message)
			}
		}
	}
}

export default withRouter(Register)